import Feedback from 'components/Feedback/styled';

export default Feedback;
